export const GET_FOLDER_STARTED = "GET_FOLDER_STARTED"
export const GET_FOLDER_SUCCESS = "GET_FOLDER_SUCCESS"
export const GET_FOLDER_FAILED = "GET_FOLDER_FAILED"